import { createFileRoute } from "@tanstack/react-router";
import { Topbar } from "@/components/calv/Topbar";
import { Footer } from "@/components/calv/Footer";
import { Hero } from "@/components/calv/Hero";
import { Section } from "@/components/calv/Section";
import { ViabilityCalculator } from "@/components/calv/ViabilityCalculator";
import { SITE_URL } from "@/lib/locale";

const TITLE = "Wirtschaftlichkeits-Rechner Performance-Marketing — Calvarius";
const DESC =
  "Berechnet aus Bestellwert, Marge und Conversion-Rate die wirtschaftlich tragfähigen CPC-Schwellen — plus Reality-Check gegen Branchen-CPC-Medianwerte.";
const URL_ = `${SITE_URL}/tools/wirtschaftlichkeitsrechner`;
const ALT = `${SITE_URL}/en/tools/profitability-calculator`;

export const Route = createFileRoute("/tools/wirtschaftlichkeitsrechner")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL_ },
      { property: "og:locale", content: "de_DE" },
      { property: "og:locale:alternate", content: "en_US" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [
      { rel: "canonical", href: URL_ },
      { rel: "alternate", hrefLang: "de", href: URL_ },
      { rel: "alternate", hrefLang: "en", href: ALT },
      { rel: "alternate", hrefLang: "x-default", href: URL_ },
    ],
  }),
  component: ProfitabilityCalculatorDE,
});

function ProfitabilityCalculatorDE() {
  return (
    <>
      <Topbar />
      <main id="main">
        <Hero
          variant="short"
          number="01"
          eyebrow="WIRTSCHAFTLICHKEITS-RECHNER · PERFORMANCE-MARKETING"
          headline={<>Lohnt sich Performance-Marketing <em>für Sie?</em></>}
          lead="Berechnet aus Ihren Bestellwert-, Marge- und Conversion-Daten die wirtschaftlich tragfähigen CPC-Schwellen — plus methodische Einordnung gegen Branchen-Realität. Keine Marketing-Bagatelle, sondern wirtschaftliche Substanz."
          breadcrumbs={[
            { label: "Start", to: "/" },
            { label: "Tools", to: "/tools" },
            { label: "Wirtschaftlichkeits-Rechner" },
          ]}
        />

        <Section
          number="02"
          kicker="Eingabe"
          headline={<>Fünf Werte. <em>Eine ehrliche Einordnung.</em></>}
          variant="tinted"
        >
          <ViabilityCalculator locale="de" />
        </Section>
      </main>
      <Footer />
    </>
  );
}
